export class EnumHelper {
  constructor() {}

  /**
   * @description converts (currently, static) ENUM to Array<string>
   */
  static asStringArray(enumToConvert: any): Array<string> {
    const returnable: Array<string> = [];
    const enumsAsArray = Object.keys(enumToConvert);
    for (const frequency of enumsAsArray) {
      returnable.push(enumToConvert[frequency]);
      }

    return returnable;
  }
}
